import { Link } from 'react-router';

export function NotFound() {
  return (
    <div className="mx-auto max-w-6xl">
      <span className="eyebrow reveal" style={{ ['--i' as string]: 0 }}>
        Off air
      </span>
      <h1
        className="display display-outline reveal mt-4 text-[clamp(6rem,22vw,16rem)]"
        style={{ ['--i' as string]: 1 }}
        aria-label="404"
      >
        404
      </h1>
      <p className="reveal mt-2 text-text-muted" style={{ ['--i' as string]: 2 }}>
        That page does not exist.{' '}
        <Link to="/" className="text-accent underline underline-offset-4 hover:text-text">
          Back to the lobby
        </Link>
        .
      </p>
    </div>
  );
}
